import { CSSProperties } from "react";

const dark = {
  mainStyles: {
    "--bg-color": "#202020",

    "--outline-color": "#BDBFBF",
    "--active-text-color": "#BDBFBF",
    "--text-color": "#BABABA",
    "--text-color-gray200": "#989898",
    "--strong-text-color": "#E5E8E8",
    "--gradient-text-color":
      "linear-gradient(180deg, #FF9900 0%, #FF7100 100%)",
    "--hidden-text-color": "#414142",
    "--icon-fill-color": "#ff7100",

    "--backing-bg-color": "#202020",

    "--input-border-color": "#333333",
    "--input-active-border-color": "var(--strong-text-color)",
    "--input-error-color": "rgba(245, 46, 46, 0.8)",

    "--default-button-bg-color": "#202020",
    "--default-button-hover-bg-color": "#2a2a2a",
    "--default-button-icon-color": "var(--icon-fill-color)",

    "--delete-button-bg-color": "rgba(245, 46, 46, 0.1)",
    "--delete-button-hover-bg-color": "rgba(245, 46, 46, 0.3)",
    "--delete-button-icon-color": "#f52e2e",

    "--success-button-bg-color": "rgba(255, 113, 0, 0.2)",
    "--success-button-hover-bg-color": "rgba(255, 113, 0, 0.4)",
  } as CSSProperties,
  gaugeStyles: {
    "--box-shadow":
      "-4px -4px 16px rgba(101, 101, 101, 0.12), -2px -2px 8px rgba(101, 101, 101, 0.12), 2px 2px 8px rgba(0, 0, 0, 0.12), 4px 4px 16px rgba(20, 20, 20, 0.47)",
    "--bg-color": "#161616",
    "--control-bg-color": "#181818",
    "--control-border-color": "#FF7100",
    "--control-box-shadow":
      "inset -8px -8px 16px rgba(0, 0, 0, 0.12), inset -1px -1px 4px rgba(0, 0, 0, 0.24), inset 0px 0px 4px rgba(101, 101, 101, 0.12), inset 8px 8px 16px rgba(101, 101, 101, 0.12)",
  } as CSSProperties,
  sectionStyles: {
    "--separator-color": "#333333",
    "--bg-color": "#212121",
    "--icon-color": "#333333",
    "--cable-shadow-color": "#202020",
    "--box-shadow":
      "-4px -4px 16px rgba(101, 101, 101, 0.12), -2px -2px 8px rgba(101, 101, 101, 0.12), 2px 2px 8px rgba(0, 0, 0, 0.12), 4px 4px 16px rgba(20, 20, 20, 0.47)",
  } as CSSProperties,
  popupStyles: {
    "--bg-color": "#181818",
    "--separator-color": "#202020",
  } as CSSProperties,
  dialogStyles: {
    "--box-shadow": "0px 8px 36px rgba(0, 0, 0, 0.16)",
    "--backing-bg-color": "#070707",
    "--default-button-bg-color": "#181818",
    "--default-button-hover-bg-color": "#121212",
    "--cancel-button-bg-color": "#212121",
    "--cancel-button-hover-bg-color": "#1e1e1e",
    "--cancel-button-border-color": "#292929",
  } as CSSProperties,
  instructionsStyles: {
    "--thumb-color": "#333333",
    "--bottom-color":
      "linear-gradient(0deg, rgba(24, 24, 24, 0.8), rgba(24, 24, 24, 0.8)), linear-gradient(180deg, rgba(14, 14, 14, 0) 0%, rgba(14, 14, 14, 0.21) 17.71%, #0E0E0E 100%)",
  } as CSSProperties,
  leftSideStyles: {
    "--bg-color": "#181818",
    "--box-shadow": "0px 1px 2px rgba(0, 0, 0, 0.32)",
    "--separator-color": "#333333",
    "--header-button-bg-color": "#1c1c1c",
  } as CSSProperties,
};

export default dark;
